import React from 'react';
import {Bg} from '../field'
import PagedView from './PagedView'
import View from './View'

const BlockView = (props) => {
	const {block, menu, config} = props

	const view = {
		id: block.uuid,
		title: block.title,
		collection: block.collection?block.collection:'node', 
		query: block.query?JSON.parse(block.query):undefined,
		projection: block.projection?JSON.parse(block.projection):undefined,
		pageSize: block.pageSize?block.pageSize:undefined,
		paginate: block.paginate?block.paginate:false,
		sort: block.sort?JSON.parse(block.sort):undefined,
		rowRenderer: block.rowRenderer,
		viewRenderer: block.viewRenderer,
		moreText: block.moreText,
		moreLink: block.moreLink,
	}
	
	return (
	<div id={config.id}
		className={config.classes.join(' ') + ' ' + block.view}
		style={config.style}>
		{config.bg && <Bg bg={config.bg} proportional={config.classes.includes('bg-prop')} container={`#${config.id} > .block-in`} screen={config.screen}/>}
		{menu}
		<div className='block-in'><div className={config.contentClasses.join(' ')} style={config.contentStyle}>
			{view.paginate 
				?<PagedView view={view}/>
				:<View view={view}/>
			}
		</div></div>
	</div>
)}
export default BlockView

/*
import React from 'react';
import { connect } from 'react-redux';
import Link from '../lib/Link'
import LazyImage from '../lib/LazyImage'
import {Bg} from '../field'
import {claim, find, release} from '../reducers/page'
import renderers from './ViewRenderer'

class BlockView extends React.Component {
	state = {
		page: 0
	}
	constructor(props) {
		super(props)
		this.next = this.next.bind(this)
		this.prev = this.prev.bind(this)
		this.first = this.first.bind(this)
		this.last = this.last.bind(this)
	}
	componentWillMount() {
		const {claim, block, lang} = this.props
		this.id = lang?`${block.uuid}-${lang}`:block.uuid
		claim(this.id)
		this.update(0)		
	}
	componentWillUnmount() {
		const {release} = this.props

		release(this.id)
	}
	first() {
		let page = 0
		this.setState({page})
		this.update(page)		
	}
	prev() {
		let page = this.state.page-1
		this.setState({page})
		this.update(page)		
	}
	next() {
		let page = this.state.page+1
		this.setState({page})
		this.update(page)		
	}
	last() {
		const {view} = this.props
		
		if (!view) return
		let pages = Math.floor(view.total / view.options.pageSize)
		let q = view.total % view.options.pageSize
		if(q>0) pages += 1
		let page = pages-1
		this.setState({page})
		this.update(page)		
	}
	update(page) {
		const {find, block, lang} = this.props
		
		find(this.id, {
				collection: block.collection?block.collection:'node', 
				query: block.query?JSON.parse(block.query):undefined,
				projection: block.projection?JSON.parse(block.projection):undefined,
				pageSize: block.pageSize?block.pageSize:undefined,
				page,
				paginate: block.paginate?block.paginate:false,
				sort: block.sort?JSON.parse(block.sort):undefined,
				lang
			})
	}
	render() {
		const {block, menu, config, view, lang} = this.props
		
		let pages = 0
		if (view) {
			pages = Math.floor(view.total / view.options.pageSize)
			let q = view.total % view.options.pageSize
			if(q>0) pages += 1
		}
		const RowRenderer = (block.rowRenderer&&renderers[block.rowRenderer])
			?renderers[block.rowRenderer]:
			renderers['row']
		
		return (
	<div id={config.id} 
		className={config.classes.join(' ') + ' ' + block.view}
		style={config.style}>
		{config.bg && <Bg bg={config.bg} proportional={config.classes.includes('bg-prop')} container={`#${config.id} > .block-in`} screen={config.screen}/>}
		{menu}
		<div className='content'>
		{view &&
			<div className='view-content'>
				{block.icon && block.icon.length>0 && <LazyImage className='image' src={block.icon[0]} alt='' screen={screen}/>}
				{block.title && <h2 className='title'>{block.title}</h2>}
				{view.data.map((item, i) => 
					<RowRenderer key={i} index={i} entity={item} lang={lang}/>
				)}
			</div>
		}			
		{view && block.paginate &&
			<div className='view-pager'>
				{view.options.page > 0 && <a className='pager-button' onClick={this.first}><i className='fa fa-angle-double-left'></i></a>}
				{view.options.page > 0 && <a className='pager-button' onClick={this.prev}><i className='fa fa-angle-left'></i></a>}
				{view.options.page < pages-1 && <a className='pager-button' onClick={this.next}><i className='fa fa-angle-right'></i></a>}
				{view.options.page < pages-1 && <a className='pager-button' onClick={this.last}><i className='fa fa-angle-double-right'></i></a>}
			</div>
		}
		
		{block.moreLink && 
			<div className='footer'><Link className='more-link' to={block.moreLink}>{block.moreText}</Link></div>
		}
		</div>
	</div>
		)
	}
}
function mapStateToProps(state, ownProps) {
	const lang = state.page.lang
	const id = lang?`${ownProps.block.uuid}-${lang}`:ownProps.block.uuid
	return {
		lang,
		view: state.page[id]
	}
}
export default connect(mapStateToProps, {claim, find, release})(BlockView);
*/


// WEBPACK FOOTER //
// ./src/fm/block/BlockView.js